import { Styles } from 'shared/types';

export const spreadMultipleStyles = (styles: Styles, sx: Styles | undefined) => [
  styles,
  ...(Array.isArray(sx) ? sx : [sx]),
];
